import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared shell for ApiHub auth pages.
 *
 * Visual structure:
 *   ah-auth (full-height dark bg with grid + accent glow)
 *     ah-auth-inner (centered column)
 *       brand + eyebrow
 *       ah-auth-card  ← children render here
 *       footer link slot ("Don't have an account?")
 *     ah-auth-bottom (status line)
 */
const AhAuthShell = ({ eyebrow, title, subtitle, children, footer, meta }) => {
  return (
    <div className="ah-auth">
      <div className="ah-auth-inner">
        <Link to="/" className="ah-auth-brand" aria-label="ApiHub home">
          <span className="api">Api</span><span className="hub">hub</span>
        </Link>
        {eyebrow && <div className="ah-auth-eyebrow">{eyebrow}</div>}

        <div className="ah-auth-card">
          {title && <h1 className="ah-auth-title">{title}</h1>}
          {subtitle && <p className="ah-auth-sub">{subtitle}</p>}
          {children}
        </div>

        {footer && <div className="ah-auth-foot">{footer}</div>}

        {meta && <div className="ah-auth-meta">{meta}</div>}
      </div>

      <div className="ah-auth-bottom">
        <span className="status-dot"></span>
        All systems normal · ApiHub © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default AhAuthShell;
